"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDiscountAdminResponseToJSON = exports.OrderDiscountAdminResponseFromJSONTyped = exports.OrderDiscountAdminResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function OrderDiscountAdminResponseFromJSON(json) {
    return OrderDiscountAdminResponseFromJSONTyped(json, false);
}
exports.OrderDiscountAdminResponseFromJSON = OrderDiscountAdminResponseFromJSON;
function OrderDiscountAdminResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, (0, _1.OrderDiscountFromJSONTyped)(json, ignoreDiscriminator)), { 'lootboxPrize': !(0, runtime_1.exists)(json, 'lootboxPrize') ? undefined : json['lootboxPrize'], 'assignedCodes': !(0, runtime_1.exists)(json, 'assignedCodes') ? undefined : (json['assignedCodes'].map(_1.OrderDiscountUserCodeFromJSON)) });
}
exports.OrderDiscountAdminResponseFromJSONTyped = OrderDiscountAdminResponseFromJSONTyped;
function OrderDiscountAdminResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign(__assign({}, (0, _1.OrderDiscountToJSON)(value)), { 'lootboxPrize': value.lootboxPrize, 'assignedCodes': value.assignedCodes === undefined ? undefined : (value.assignedCodes.map(_1.OrderDiscountUserCodeToJSON)) });
}
exports.OrderDiscountAdminResponseToJSON = OrderDiscountAdminResponseToJSON;
